<h4>Movimentos do fundo {{data.fundo.cnpjFundo}} - {{data.fundo.nomeFundo}}</h4>

<ol>
  <li style="display: flex;" *ngFor="let item of data.fundo.movimentosSimulador" >
    <h5>{{item.operacao == -1 ? 'Resgate' : 'Aplicação'}}</h5>
    <span style="flex: 1;"></span>
    <h5>{{item.valor | currency: 'BRL'}}</h5>
  </li>
</ol>